"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("@completeanatomy/config");
const ui_1 = require("@completeanatomy/ui");
const PanelItem_1 = __importDefault(require("../../atoms/PanelItem"));
const ScrollContainer_1 = __importDefault(require("../../atoms/ScrollContainer"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const SidebarTabs_1 = require("../SidebarTabs");
function Sidebar({ name, parts, onClick, selectedPart, tabName, }) {
    var _a;
    const tabs = {
        TabName: tabName,
        DescriptionTab: 'Description',
    };
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(tabs.TabName);
    const config = (0, config_1.useConfigService)();
    const onTabClick = (tab) => {
        if (tab === selectedTab) {
            return;
        }
        setSelectedTab(tab);
    };
    const imageBaseUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    (0, react_1.useEffect)(() => {
        var _a;
        const item = document.getElementById('sidebar-selected-spot');
        (_a = item === null || item === void 0 ? void 0 : item.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(item, {
            behavior: 'smooth',
            block: 'center',
        });
    }, [parts]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail) ? ((0, jsx_runtime_1.jsx)(SidebarTabs_1.SidebarTabs, { selectedTab: selectedTab, tabs: tabs, onTabClick: onTabClick, "data-e2e": 'Sidebar_SidebarTabs' })) : ((0, jsx_runtime_1.jsx)(ClasterName, { "data-e2e": 'Sidebar_ClasterName', children: name })), selectedTab === tabs.TabName ? ((0, jsx_runtime_1.jsx)(ScrollContainer_1.default, { "data-e2e": 'Sidebar_ScrollContainer', children: parts.map(part => ((0, jsx_runtime_1.jsx)(PanelItem_1.default, { id: part.isSelected ? 'sidebar-selected-spot' : undefined, onClick: () => onClick(part), isSelected: (selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.identifier) === part.identifier, image: imageBaseUrl + part.img, text: part.title, "data-e2e": 'Sidebar_PanelItem' }, part.identifier + `${part.isSelected ? 'selected' : ''}`))) })) : ((0, jsx_runtime_1.jsx)(ui_1.InfoContainer, { descriptionText: (_a = selectedPart === null || selectedPart === void 0 ? void 0 : selectedPart.detail) !== null && _a !== void 0 ? _a : '', "data-e2e": 'Sidebar_InfoContainer' }))] }));
}
exports.Sidebar = Sidebar;
const ClasterName = styled_components_1.default.h2 `
  font-size: 20px;
  margin-top: 10px;
`;
